module.exports = __webpack_public_path__ + "img/icongeography.372e092d.png";